import React, { useRef, useState } from "react";
import styles from "./banners.module.scss";
import { Outlet } from "react-router-dom";
import NavTabs from "../../components/mui/tabs/NavTab";
import StatusCard from "../../components/uiComponents/statusCard/StatusCard";
const tabs = [
  {
    id: "1",
    title: "Active",
    link: "/banner",
  },
  {
    id: "2",
    title: "InActive",
    link: "/banner/inActive",
  },
];

const Banners = () => {
  return (
    <div className={styles.container}>
      {/* <div className={styles.heading}>OFFERS</div> */}
      <StatusCard
        leftContent="BANNER" // or any icon/component
      />

      <div className={styles.top}>
        <NavTabs data={tabs} variant={"fullWidth"} />
      </div>

      <div className={styles.bottom}>
        <Outlet />
      </div>
    </div>
  );
};

export default Banners;
